import {t} from 'i18next';
import {useMemo} from 'react';
import {CustomFieldSection} from './CustomFieldSection';
import {CustomInfo, ICustomInfoProps} from './CustomInfo';
import {
  FieldType,
  FieldUIType,
  FieldUITypeMappingObj,
  IFieldModal,
} from './constant';

const FieldTypeFormat: Record<number, string> = {
  2: 'YYYY/MM/DD HH:MM:SS',
  9: 'HH:MM:SS',
  10: 'YYYY/MM/DD',
  5: 'Integer',
  11: 'Float',
};

interface FieldCategoryMetadataDetailsProps {
  fieldData?: IFieldModal;
  editModeParamKey?: string;
  disabled?: boolean;
  onSaveKey?: (paramKey: string, value?: string) => void;
  onChangeEditMode?: (paramKey: string, isEditMode: boolean) => void;
  canEditCustomFields?: boolean;
}

const FieldCategoryMetadataDetails: React.FC<
  FieldCategoryMetadataDetailsProps
> = ({
  fieldData,
  editModeParamKey,
  disabled,
  onSaveKey,
  onChangeEditMode,
  canEditCustomFields,
}) => {
  const values: ICustomInfoProps = useMemo(() => {
    const fieldTypeId = fieldData?.fieldTypeId as FieldUIType;

    const value1 = {
      title: t('fieldManagement.customField.fieldType'),
      value: fieldData?.fieldUIType,
    };
    let value2, value3, value4;
    if (
      FieldUITypeMappingObj[fieldTypeId] === 'Text' ||
      FieldUITypeMappingObj[fieldTypeId] === 'Keyword' ||
      FieldUITypeMappingObj[fieldTypeId] === 'TextMultivalue' ||
      FieldUITypeMappingObj[fieldTypeId] === 'ExtractedText'
    ) {
      value3 = undefined;

      /*
      value3 = {
        title: t('fieldManagement.customField.multiValueField'),
        value: fieldData?.isMultiValueField
          ? t('fieldManagement.customField.yes')
          : t('fieldManagement.customField.no'),
      };
      */

      if (FieldUITypeMappingObj[fieldTypeId] === 'Text') {
        value3 = undefined;
      }

      if ((fieldData?.isRelationalEditable ?? false) && canEditCustomFields) {
        value2 = {
          title: t('fieldManagement.customField.relationshipField'),
          value: fieldData?.isRelationShipField
            ? t('fieldManagement.customField.yes')
            : t('fieldManagement.customField.no'),
          isEditable: true,
          paramKey: 'isRelationShipField',
          isEditModeDisabled: !canEditCustomFields,
          optionArray: [
            t('fieldManagement.customField.yes'),
            t('fieldManagement.customField.no'),
          ],
        };
      } else if (fieldData?.isMultiValueField === false) {
        value2 = {
          title: t('fieldManagement.customField.relationshipField'),
          value: fieldData?.isRelationShipField
            ? t('fieldManagement.customField.yes')
            : t('fieldManagement.customField.no'),
        };
      }
    }
    if (
      FieldUITypeMappingObj[fieldTypeId] === 'DateTime' ||
      FieldUITypeMappingObj[fieldTypeId] === 'Date' ||
      FieldUITypeMappingObj[fieldTypeId] === 'Time'
    ) {
      value3 = {
        title: t('fieldManagement.customField.format'),
        value: FieldTypeFormat[fieldTypeId],
      };
    }
    if (
      FieldUITypeMappingObj[fieldTypeId] === 'Number' ||
      FieldUITypeMappingObj[fieldTypeId] === 'Float'
    ) {
      value1.value = t('fieldManagement.customField.number') as FieldType;
      value3 = {
        title: t('fieldManagement.customField.numberType'),
        value: FieldTypeFormat[fieldTypeId],
      };
    }
    return {
      value1,
      value2,
      value3,
      value4,
    };
  }, [
    canEditCustomFields,
    fieldData?.fieldTypeId,
    fieldData?.fieldUIType,
    fieldData?.isMultiValueField,
    fieldData?.isRelationShipField,
    fieldData?.isRelationalEditable,
  ]);

  return (
    <CustomFieldSection title={t('fieldManagement.customField.details')}>
      <CustomInfo
        {...values}
        editModeParamKey={editModeParamKey}
        disabled={disabled}
        onSaveKey={onSaveKey}
        onChangeEditMode={onChangeEditMode}
      />
    </CustomFieldSection>
  );
};

export {FieldCategoryMetadataDetails};
